/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Create_Team_ButtonInputs */



/**
* | output |
* | --- |
* | "Create Team" |
*
* @param {Team_Manager_Create_Team_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_create_team_button = /** @type {((inputs?: Team_Manager_Create_Team_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Create_Team_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer une équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать команду")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建团队")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームを作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar equipe")
	return /** @type {LocalizedString} */ ("Create Team")
});